import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";
import { withRouter, RouteComponentProps, useHistory } from "react-router";
import useInjectSaga from "../../../../../utils/injectSaga";
import useInjectReducer from "../../../../../utils/injectReducer";
import {
  getLoading,
  getRefreshStatus,
  getNetworkStatus,
  getUserMasterData,
  getStofKey,
} from "../../../../../selectors/selector";
import {
  PLEASE_CHECK_NETWORK_CONNECTIVITY_MESSAGE,
  NO_NETWORK,
  FAVORITE_ALREADY_EXIST_TITLE,
  LIST_FULL_TITLE,
  MESSAGE_TEXT,
} from "../../../../../utils/constants";
import { updateFavoriteData } from "../../../../../actions/Favorite/action";
import { SearchResultPage } from "../../../../../web/pages/Search/SavedSearch/SearchResults";
import {
  getOffSet,
  isStofLoaded,
  makeSearch,
  makeStofLoads,
  makeStofTotalLoads,
} from "../../../../../selectors/Search/selector";
import searchReducer from "../../../../../reducers/Search/reducer";
import saga from "../../../../../saga/Search/Search.saga";
import homeSaga from "../../../../../saga/Home/saga";
import {
  SEARCH_DATA,
  fetchResults,
  removeSearchResults,
  getStofLoads,
} from "../../../../../actions/Search/action";
import { toggleWatchLoad } from "../../../../../web/utils/watchedUtil";
import { makeSelectWatched } from "../../../../../selectors/Home/selector";
import { showAlert } from "../../../../../actions/App/action";
import { Favorite } from "../../../../../models/home/favorite.model";
import { getDriverList } from "../../../../../selectors/carrierAssign/selector";
import { clearFavoriteError } from "../../../../../actions/Recent/action";
import {
  getLoadData,
  getBookLoadStatus,
  getCarrierAssignedLoads,
  getShipmentDetails as xdd,
  getShipmentDetails,
} from "../../../../../selectors/Myload/selector";
import { fetchShipments } from "../../../../../actions/carrierAssign/action";
import {
  addWatchLoad,
  removeWatchLoad,
  removeRecommendedResults,
  removeWatchLoadSuccess,
} from "../../../../../actions/Home/action";
import {
  buyLoadRequest,
  buyLoadShipmentRequest,
  buyLoadStatusRemove,
} from "../../../../../actions/BookLoad/action";
import { favoriteError } from "../../../../../selectors/RecentSearch/selector";
import { CustomModal } from "../../../../../components/CustomModal";
import { StofModel } from "../../../../../models/Stof/Stof.model";
import { IUserDetails } from "../../../../../schemas/user";
import { IEShipmentResponse } from "app/schemas/getShipment/GetShipment.schema";

const key = "search";
let params = {};
const pageSize: number = 25;
export interface ResultProps extends RouteComponentProps {
  searchData: any;
  location: any;
  data: any;
  loading: any;
  history: any;
  fetchData: any;
  userDetails: IUserDetails;
  isInPullToRefresh: boolean;
  isNetworkAvailable: boolean;
  showAlert: Function;
  buyLoadRequest: any;
  bookLoadStatus: any;
  getShipmentDetails: any;
  buyLoadStatusRemove: any;
  buyLoadShipmentRequest: any;
  fetchShipments: any;
  carrierLoads: any;
  removeSearchResults: any;
  removeRecommendedResults: any;
  removewatchedResults: any;
  searchNewInput: any;
  showResults: boolean;
}

export const SearchResultContainer: React.FC<ResultProps> = (props: any) => {
  const {
    location,
    history,
    fetchData,
    userDetails,
    isInPullToRefresh,
    isNetworkAvailable,
    showAlert,
    bookLoadStatus,
    getShipmentDetails,
    buyLoadRequest,
    buyLoadShipmentRequest,
    carrierLoads,
    removeRecommendedResults,
    removewatchedResults,
    searchNewInput,
    showResults = false,
    watchedLoadList,
    buyLoadStatusRemove,
    errorData
  } = props;

  let { data, stofLoads } = props;
  const searchInput =
    searchNewInput || history?.location?.state?.searchInput;
  const showResult =
    showResults || (location && location.state && location.state.showResults);
  const detailObj = location && location.state && location.state.detailObj;
  const tabFrom = location && location.state && location.state.tabFrom;
  const modelF = new Favorite();
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [updateFlag, setUpdateFlag] = useState(false);
  const [isStof, setStof] = useState<boolean>(false);
  const [favoriteErrorTitle, setFavoriteErrorTitle] = useState('');
  const [favoriteErrorMessage, setFavoriteErrorMessage] = useState('');
  const [shouldShowLoadMoreUpdate,setShouldShowLoadMoreUpdate]= useState<boolean>(false);
  const shipmentDetails: IEShipmentResponse = useSelector(xdd());
  const offSetValues = useSelector(getOffSet())
  const shipmentDetailsAfterBookLoad: any = shipmentDetails?.shipments
                              && shipmentDetails?.shipments?.length > 0 
                              ? shipmentDetails?.shipments[0] : [];
  if (isStof) {
    data = { searchLoads: stofLoads, totalRecords: props.stofTotalLoads };
  }
  useEffect(() => {
    if (
      location.pathname === "/app/search/results" &&
      errorData &&
      errorData.updateUserSearchHistoryAsFavorite
    ) {
      const favoriteErrorMessage = errorData.updateUserSearchHistoryAsFavorite.errorMessage;
      const favoriteErrorTitle = favoriteErrorMessage.indexOf(MESSAGE_TEXT) !== -1 ? LIST_FULL_TITLE : FAVORITE_ALREADY_EXIST_TITLE ;
      setShowErrorPopup(true);
      setFavoriteErrorTitle(favoriteErrorTitle);
      setFavoriteErrorMessage(favoriteErrorMessage)
      setUpdateFlag(true);
    }
  }, [errorData]);
  const userPrincipalName: string =
    (props.userDetails && props.userDetails.memberDetailsResponse &&
      props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.upn) || "";

  const [currentPage, onChangePage] = useState<number>(0);
  const [sortColumn, onSortColumn] = useState<string>("pickUpStartDate");
  const [sortDirection, onSortDirection] = useState<string>("asc");
  const [stateId, setStateId] = useState<string>("");
  const [countryId, setCountryId] = useState<string>("");

  useEffect(() => {
    if (stateId && userPrincipalName) {
      const userDetails: any = props.userDetails || {};
      let role: string = "";
      if (
        userDetails && userDetails.memberDetailsResponse &&
        userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.userApplicationDetails &&
        userDetails.memberDetailsResponse.member.userApplicationDetails.length > 0
      ) {
        role =
          userDetails.memberDetailsResponse.member.userApplicationDetails[0] &&
          userDetails.memberDetailsResponse.member.userApplicationDetails[0].roles &&
          userDetails.memberDetailsResponse.member.userApplicationDetails[0].roles.length > 0 &&
          userDetails.memberDetailsResponse.member.userApplicationDetails[0].roles[0].roleName;
      }
      const model: StofModel = new StofModel();
      model.page = currentPage;
      model.size = pageSize;
      model.country = countryId;
      model.stateId = stateId;
      model.carrierId = userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId;
      model.userRole = role;
      model.carrierScac = userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.carrierScac;
      model.carrierTier = userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.carrierTier;
      model.managedEquipmentCapability =
      userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.managedEquipmentCapability;
      model.nonManagedEquipmentCapability =
      userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.nonManagedEquipmentCapability;
      model.sortColumn = sortColumn;
      model.sortDirection = sortDirection;
      props.getStofLoad(model.getStateBasedLoad(), currentPage, currentPage > 0 ? stofLoads: [],
      ()=>setShouldShowLoadMoreUpdate((prevValue:boolean)=>!prevValue));
    }
  }, [stateId, JSON.stringify(userPrincipalName), currentPage, sortColumn, sortDirection,countryId]);

  useEffect(() => {
    const stateCode = window.sessionStorage.getItem("stateCode");
    const countryCode = window.sessionStorage.getItem("countryCode");
    if (stateCode || countryCode) {
      stateCode && setStateId(stateCode);
      stateCode && setStof(true);
      stateCode && window.sessionStorage.removeItem("stateCode");
      countryCode && setCountryId(countryCode);
      countryCode && setStof(true);
      countryCode && window.sessionStorage.removeItem("countryCode");
    }
  }, []);
  
  const {
    location: { pathname },
  } = useHistory();

  useEffect(() => {
    if (pathname != "/app/stof") {
      setStof(false);
    }
  }, [pathname]);

  const finalList = () => {
    return (
      data.searchLoads &&
      data.searchLoads.map((load: any) => ({
        ...load,
        isWatched:
          watchedLoadList.find(
            (details: any) => details.loadId === load.loadId
          ) !== undefined,
      }))
    );
  };

  const updateFavorite = (fav: boolean, loadData: any) => {
    setUpdateFlag(false);
    if (!props.isNetworkAvailable) {
      showAlert({
        isShowAlert: true,
        alertMessage: PLEASE_CHECK_NETWORK_CONNECTIVITY_MESSAGE,
        alertTitle: NO_NETWORK,
      });
      return;
    }
    const {destinationState1=null,destinationState2=null,destinationState3=null,...restLoadData} = loadData;
    const newData = {
      ...restLoadData,
      pickupdate: restLoadData.pickupdate,
      searchdate: restLoadData.searchdate,
      dropdate: restLoadData.destinationCity === null ? null : restLoadData.dropdate,
      favouritesearchindicator: fav,
    };
    if(!restLoadData.destinationState && (destinationState1 || destinationState2 || destinationState3)){
      let temp = [];
      destinationState1 && temp.push(destinationState1);
      destinationState2 && temp.push(destinationState2);
      destinationState3 && temp.push(destinationState3);
      newData.destinationStates = temp;
    }
    if (!fav) {
      props.updateFavoriteLoads(modelF.updateFavoriteLoad(newData), false);
    } else {
      props.updateFavoriteLoads(
        modelF.updateFavoriteLoadCheckDuplicate(newData),
        false
      );
    }
  };
  if (location.state && location.state.params) {
    params = location.state.params;
  }
  if (history.location) {
    return (
      <>
        <SearchResultPage
        {...props}
          results={{
            searchLoads: finalList() || [],
            totalRecords: data.totalRecords || 0,
          }}
          detailObj={detailObj}
          tabFrom={tabFrom}
          params={params}
          history={history}
          showResult={isStof || showResult}
          isStof={isStof}
          isStofLoaded={props.isStofLoaded}
          pathname={pathname}
          userDetails={userDetails}
          searchInput={searchInput}
          updateFavorite={updateFavorite}
          updateFlag={updateFlag}
          totalRecords={data.totalRecords}
          handleSortingPagination={(
            inputs: any,
            isPagination: boolean = false,
            isHideLoader: boolean = false,
          ) => {
            fetchData(
              inputs.getRequestPayload(),
              isPagination || false,
              isHideLoader,
              ()=>setShouldShowLoadMoreUpdate((prevValue:boolean)=>!prevValue)
            );
          }}
          onResetPagination={() => {
          }}
          isInPullToRefresh={isInPullToRefresh}
          showAlert={showAlert}
          isNetworkAvailable={isNetworkAvailable}
          buyLoadRequest={buyLoadRequest}
          bookLoadStatus={bookLoadStatus}
          getShipmentDetails={getShipmentDetails}
          buyLoadStatusRemove={buyLoadStatusRemove}
          buyLoadShipmentRequest={buyLoadShipmentRequest}
          fetchShipments={fetchShipments}
          carrierLoads={carrierLoads}
          toggleWatchLoad={toggleWatchLoad(props)}
          removeRecommendedResults={removeRecommendedResults}
          removewatchedResults={removewatchedResults}
          onChangePage={() => {
            onChangePage(currentPage + 1);
          }}
          onSorting={(column: string, direction: string)=>{
            onSortColumn(column);
            onSortDirection(direction);
            onChangePage(0);
          }}
          shouldShowLoadMoreUpdate={shouldShowLoadMoreUpdate}
          stofCurrentPage={currentPage}
          stofPageSize = {pageSize}
          shipmentDetailsAfterBookLoad={shipmentDetailsAfterBookLoad}
          offSetValues={offSetValues}
        />
        <div
          data-test="error-state"
          onClick={() => {
            setShowErrorPopup(false);
            props.clearErrorState();
          }}
        >
          <CustomModal
            isOpen={showErrorPopup}
            title={favoriteErrorTitle}
            message={favoriteErrorMessage}
            buttons={[{ label: "Ok", callback: () => {} }]}
          />
        </div>
      </>
    );
  }
  return null;
};

const mapStateToProps = createStructuredSelector({
  loading: getLoading(),
  data: makeSearch(),
  errorData: favoriteError(),
  userDetails: getUserMasterData(),
  isInPullToRefresh: getRefreshStatus(),
  isNetworkAvailable: getNetworkStatus(),
  driverList: getDriverList(),
  loadData: getLoadData(),
  watchedLoadList: makeSelectWatched(),
  bookLoadStatus: getBookLoadStatus(),
  getShipmentDetails: getShipmentDetails(),
  carrierLoads: getCarrierAssignedLoads(),
  stofLoads: makeStofLoads(),
  isStofLoaded: isStofLoaded(),
  STOF_KEY: getStofKey(),
  stofTotalLoads: makeStofTotalLoads(),
});

export const mapDispatchToProps = (dispatch: Function) => ({
  getStofLoad: (payload: any, currentPage: number, oldLoads: any[],callback:any) => {
    dispatch(getStofLoads(payload, currentPage, oldLoads,callback));
  },
  searchData: (data: any) => dispatch(SEARCH_DATA(data)),
  fetchData: (searchdata: any, isPagination: boolean, isHideLoader: boolean,callback:any) =>
    dispatch(fetchResults(searchdata, isPagination, isHideLoader,callback)),
  showAlert: (data: any) => dispatch(showAlert(data)),
  addWatchLoad: (payload: any) => dispatch(addWatchLoad(payload)),
  removeWatchLoad: (payload: any) => dispatch(removeWatchLoad(payload)),
  buyLoadRequest: (payload: any) => dispatch(buyLoadRequest(payload)),
  clearErrorState: () => dispatch(clearFavoriteError()),
  buyLoadStatusRemove: () => dispatch(buyLoadStatusRemove()),
  buyLoadShipmentRequest: (payload: any, renderCallback: Function) =>
    dispatch(buyLoadShipmentRequest(payload, renderCallback)),
  fetchShipments: (details: any, callBack: any) =>
    dispatch(fetchShipments(details, false, callBack)),
  removeSearchResults: (data: any) => dispatch(removeSearchResults(data)),
  removeRecommendedResults: (data: any) =>
    dispatch(removeRecommendedResults(data)),
  removewatchedResults: (payload: any) =>
    dispatch(removeWatchLoadSuccess(payload)),
  updateFavoriteLoads: (favoriteSearch: any, isHideLoader: boolean) =>
    dispatch(updateFavoriteData(favoriteSearch, isHideLoader)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withSearchReducer = useInjectReducer({ key, reducer: searchReducer });
const withSaga = useInjectSaga({ key, saga });
const withHomeSaga = useInjectSaga({ key: "carrier", saga: homeSaga });

export default compose<any>(
  withSaga,
  withHomeSaga,
  withSearchReducer,
  withConnect
)(withRouter(SearchResultContainer));
